import { Reveal } from "@/components/Reveal";

const quotes = [
  {
    quote: "I had the photos on my phone and zero idea what to do with them. Six months with VOGUEVERVE and I signed my first beauty campaign.",
    name: "Lena K.",
    role: "Beauty & Editorial",
  },
  {
    quote: "They rebuilt my whole book and put me in rooms I couldn't get into alone. The ambassador deal changed everything.",
    name: "Amara D.",
    role: "Brand Ambassador",
  },
  {
    quote: "Professional, ruthless in the best way, and genuinely invested. They negotiate like the money is theirs.",
    name: "Sofia R.",
    role: "Runway & Commercial",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[#0a0a0a] text-[#ffffff] py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <Reveal>
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[#ffffff]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#ffffff]/60">
              The Voices
            </span>
          </div>
          <p className="font-script text-[#ffffff] text-4xl md:text-6xl leading-none mb-16">
            she was exactly where you are.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/15 border border-white/15">
          {quotes.map((q, i) => (
            <Reveal key={q.name} delay={i * 0.1} className="bg-[#0a0a0a]">
              <div data-testid={`testimonial-${i}`} className="p-8 md:p-12 h-full flex flex-col justify-between min-h-[360px]">
                <span className="font-display text-7xl text-[#ffffff] leading-none">&ldquo;</span>
                <p className="font-display text-xl md:text-2xl font-light leading-snug mt-4">
                  {q.quote}
                </p>
                <div className="mt-8 pt-6 border-t border-white/15">
                  <p className="font-bold uppercase tracking-[0.15em] text-sm">{q.name}</p>
                  <p className="text-[#ffffff]/50 text-xs uppercase tracking-[0.2em] mt-1">{q.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
